




































import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import {
    IDictionary,
    IFormControl,
    IListItem,
    ISite,
    GroupBy,
    DateRangeMapper,
    ISiteTypeListModel
} from '../../../entities';
import * as types from '../../../store/types';
import { FormFilterComponent } from '../../../components/base/form-filter/form-filter.component';

import sitesApi from '@/api/sites.api';
import typesApi from '@/api/site-types.api';
// import { ISite } from '@/entities/sites/site.interface';
// import * as types from '@/store/types';
import { mapGetters } from 'vuex';

import {
    createBigPeriodListItems,
    parsePeriodListItem,
    parseDate,
    formatDate
} from '../../../utils';

const initTypes: IListItem[] = [{ heading: 'All', value: null }];

@Component({})
export default class SaleLogsCriteriaComponent extends FormFilterComponent {
    public formState: IDictionary<IFormControl> = {
        siteId: {
            key: 'siteId',
            label: 'Site',
            value: null
        },
        typeId: {
            key: 'typeId',
            label: 'Type',
            value: null
        }
    };

    public sites: IListItem[] = [{ heading: 'Choose a site', value: null }];
    public types: IListItem[] = [{ heading: 'Choose a type', value: null }];
    public sitesInProgress: boolean = false;
    public typesInProgress: boolean = false;

    public defaultFormValues(): IDictionary<any> {
        return {
            siteId: null,
            typeId: null
        };
    }

    public async created() {
        this.sitesInProgress = true;
        try {
            const withSuspended = true;
            const items = await sitesApi.list(withSuspended);
            const mapped: IListItem[] = items.map((x) => {
                return { value: x.id, heading: x.sitename };
            });
            this.sites = [{ heading: 'Choose a site', value: null }, ...mapped];
        } finally {
            this.sitesInProgress = false;
        }

        this.doSearch();
    }

    public getQueryObject(formState: IDictionary<IFormControl>) {
        return {
            siteId: formState.siteId.value,
            typeId: formState.typeId.value
        };
    }

    @Emit()
    public search(body) {
        // empty
    }

    @Watch('formState.siteId.value')
    private onSiteIdChanged(val: string, oldVal: string) {
        this._reloadTypes(this.formState.siteId.value);
    }

    @Watch('formState.typeId.value')
    private onTypeIdChanged(val: string, oldVal: string) {
        this.submit();
    }

    @Watch('$route')
    private onRouteChanged(val: string, oldVal: string) {
        this.doSearch();
    }

    private async _reloadTypes(siteId: number = null) {
        if (!siteId) {
            this.types = [...initTypes];
            return;
        }
        this.typesInProgress = true;
        try {
            const items = await typesApi.list(siteId, {
                sortField: 'typename',
                sortAsc: true
            });
            const mapped: IListItem[] = items.map((x) => {
                return { heading: x.typename, value: x.id };
            });
            this.types = [{ heading: 'Choose a type', value: null }, ...mapped];
            // drop current type
            if (
                !mapped.find(
                    (x) => x.value === Number(this.formState.typeId.value)
                )
            ) {
                this.formState.typeId.value = null;
            }
        } finally {
            this.typesInProgress = false;
        }
    }
}
